import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import React from 'react';
import { ListHed, NoResultsText, StyledUl } from './NoResults.styles';

const NoResults: React.FC = () => {
  const inputValue = (document.getElementById('couple-search-input') as HTMLInputElement).value;
  return (
    <div>
      <NoResultsText>Hm… we couldn&apos;t find &quot;{inputValue}&quot;.</NoResultsText>

      <div>
        <ListHed> Here are some things to try: </ListHed>
        <StyledUl>
          <li> Search their full first and last names</li>
          <li> Use their proper names (Katherine vs. Kate) or nicknames (Joe vs. Joseph) </li>
          <li> Check your invite for their wedding website or registry URL </li>
          <li>
            Looking for a baby registry?{' '}
            <LinkV2 subtle inline href="https://baby.zola.com/search/baby-registry">
              Search here
            </LinkV2>
          </li>
          <li>
            Visit{' '}
            <LinkV2
              subtle
              inline
              href="/faq/115002318552-how-do-i-find-a-couple-s-zola-registry-or-wedding-website-"
            >
              this page
            </LinkV2>{' '}
            for more help
          </li>
        </StyledUl>
        <p>
          You can also get in touch at{' '}
          <LinkV2 inline href="mailto:support@zola.com">
            support@zola.com{' '}
          </LinkV2>{' '}
          or <LinkV2 href="tel:+14086579652">1 (408) 657-ZOLA.</LinkV2>
        </p>
      </div>
    </div>
  );
};

export default NoResults;
